import React from 'react';
import { connect } from 'react-redux';

import './footer.css';
import Render from './render';
import { IFooterProps } from '../../definitions/footer';

class Footer extends React.PureComponent<IFooterProps> {
  render() {
    return Render.call(this, this.props, this.state);
  }
}

const state = ({ menus, surgeonWarning: { warning } }) => ({
  menu: menus.footer,
  warning
});

export default connect(state)(Footer);



// WEBPACK FOOTER //
// ./src/containers/Footer/index.tsx